import { h, Component } from 'preact';
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import Renderer from "../canvas/renderer";
import constants from '../constants';
import util from '../util';
import { DownOutlined, FontColorsOutlined } from '@ant-design/icons';

export default @connect(reduce, actions)
class TextLineWidget extends Component {
  constructor() {
    super();

    this.onWidthChange = this.onWidthChange.bind(this);

    this.getLineCss = () => {
      const $element = this.props.$element;
      if (!$element) return;
      if ($element.attr('data-color-line')) {
        return util.getCssFromColorData($element.attr('data-color-line'));
      } else if ($element.attr('style').indexOf('border-bottom') > -1) {
        return $element.css('border-bottom-color');
      } else {
        return '#000';
      }
    }
  }

  onWidthChange(ev) {
    const value = ev.target.value;
    Renderer.updateElementStyle(this.props.isMultiSelect ? this.props.$elements : this.props.$element, 'border-bottom', `${value / 10}rem solid ${this.props.borderBottomColor}`);
    this.props.$element.attr('data-bb-width', value);
    this.props.updateElementAttribute('borderBottomWidth', value);
  }

  render(props) {
    return (
      <div className="dropdown sizes">
        {!props.isMobileVersion && <a className="dropdown-toggle car">Line</a>}
        {props.isMobileVersion && <a className="dropdown-toggle mobile-tool-widget">
          <FontColorsOutlined />
          <span>Line</span>
        </a>}

        <div className={'dropdown-menu text-fill-widget line'} data-close="no">
          {props.isMobileVersion && <div className="mobile-dropdown-header">
            <span>Line</span>
            <div className="dropdown-toggle"><DownOutlined /></div>
          </div>}
          <ul className="slider-list">
            <li className="slider-item">
              <div className={'color'}>
                <label>Color</label>
                <a onClick={() => this.props.openColorPicker(constants.pickerTypes.textLine)}>
                  <span className="color-box" style={`background: ${this.getLineCss()}; float: none;`}></span>
                </a>
              </div>
              <div className={'opacity slider-wrap'}>
                <label>Width</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="10" step="1" value={props.borderBottomWidth} onChange={this.onWidthChange} />
                </div>
                <span className={'val'}>{props.borderBottomWidth}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
